const isProd = process.env.NODE_ENV === "production";

const genId = () =>
  globalThis.crypto && globalThis.crypto.randomUUID
    ? globalThis.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const hasConsent = () => {
  try {
    return localStorage.getItem("cookieConsent") === "accepted";
  } catch {
    return false;
  }
};

// Dispara o evento no Pixel (browser) e, em produção com consentimento,
// reenvia-o server-side (CAPI) com o MESMO event_id para a Meta deduplicar.
export const trackPixel = (event, userData = {}) => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;

  const eventId = genId();
  window.fbq("track", event, {}, { eventID: eventId });

  if (!isProd || !hasConsent()) return;

  try {
    const body = JSON.stringify({
      event_name: event,
      event_id: eventId,
      event_source_url: window.location.href,
      email: userData.email || undefined,
      phone: userData.phone || undefined,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        "/api/meta-capi.php",
        new Blob([body], { type: "application/json" })
      );
    } else {
      fetch("/api/meta-capi.php", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
    }
  } catch {
    /* falha silenciosa — não afeta o Pixel do browser */
  }
};
